import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback for older browsers / non-secure contexts
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}

/**
 * CopyButton — copies `text` (string or () => string) and shows a brief "Copied" state.
 * `onCopied` lets callers track analytics.
 */
export default function CopyButton({ text, label = "Copy Prompt", copiedLabel = "Copied!", size = "default", variant = "default", className, onCopied, ...rest }) {
  const [copied, setCopied] = useState(false);
  const handle = async () => {
    const value = typeof text === "function" ? text() : text;
    const ok = await copyText(value || "");
    if (ok) {
      setCopied(true);
      toast.success("Prompt copied — paste it into your AI tool.");
      onCopied?.(value);
      setTimeout(() => setCopied(false), 1800);
    } else {
      toast.error("Couldn't copy. Select the text and copy manually.");
    }
  };
  return (
    <Button type="button" size={size} variant={variant} className={className} onClick={handle} {...rest}>
      {copied ? <Check className="mr-2 h-4 w-4" /> : <Copy className="mr-2 h-4 w-4" />}
      {copied ? copiedLabel : label}
    </Button>
  );
}
